export default "__VITE_ASSET__CDx4xC81__"